import { BCMSRecord, useBCMSContext, useStateManager } from "@bcm-dev/bcms-vite";
import { PageContainer, PageContentView } from "components/shared";
import Classes, { ACHBatch } from "model";
import HistoryACHWidget from "../ActivityACHPage/components/HistoryACHWidget";

import "./styles.css";

export default function ACHHistoryPage(props) {
    const globalController = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, globalController);

    const data = { ...getDefaultData(), ...props.data ?? {} };
    const ui = { ...getDefaultUI(), ...props.ui ?? {} };

    const controller = (state, setState) => ({
        data: state.data,
        ui: state.ui
    });

    return (
        <PageContainer className="ach-history-page" state={{ data, ui }} controller={ controller }>
            <ACHHistoryContent />
        </PageContainer>
    );
}

export const getDefaultData = () => ({
    showSearchOptions: false,
    viewLatestForRecurringBatches: true,
    achBatches: ACHBatch.initAll().filter(item => item.status === "canceled", [])
});

export const getDefaultUI = () => ({
    // No default ui for the page yet
});

function ACHHistoryContent(props) {
    const { data, ui } = useStateManager() ?? {};

    return (
        <PageContentView>
            <div className="flex-container flex-vertical flex-width">
                <HistoryACHWidget data={ data } ui={ ui } />
            </div>
        </PageContentView>
    );
}